"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PanelGroupDescriptionStyled = void 0;
const Panel_1 = require("../../components/Panel/Panel");
const constants_1 = require("../../theme/constants");
exports.PanelGroupDescriptionStyled = styled(Panel_1.Panel) `
&.octo {
  display: flex;
  justify-content: stretch;

  @media (min-width: ${constants_1.sizes.tablet}) {
    flex-flow: row nowrap;
    gap: 2em;
    align-items: stretch;
  }

  @media (max-width: ${constants_1.sizes.tablet}) {
    flex-flow: column nowrap;
    gap: 1em;
    align-items: center;
  }

  > img {
    @media (min-width: ${constants_1.sizes.tablet}) {
      width: 8em;
      height: 8em;
    }

    @media (max-width: ${constants_1.sizes.tablet}) {
      width: 12em;
      height: 12em;
    }
  }

  >.infos {
    display: flex;
    flex: 1;
    flex-flow: column nowrap;
    gap: 1em;
    justify-content: stretch;
    width: 100%;

    @media (min-width: ${constants_1.sizes.tablet}) {
      align-items: stretch;
    }

    @media (max-width: ${constants_1.sizes.tablet}) {
      align-items: center;
    }

    >.count {
      font-weight: 600;
    }

    >.description-controls {
      display: flex;
      gap: 1em;
      width: 100%;

      @media (min-width: ${constants_1.sizes.tablet}) {
        flex-flow: row nowrap;
        align-items: stretch;
        justify-content: flex-end;
      }

      @media (max-width: ${constants_1.sizes.tablet}) {
        flex-flow: column nowrap;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
`;
//# sourceMappingURL=PanelGroupDescription.styled.js.map